// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportsTable_wrapper__RRiPh","tableGeneral":"ReportsTable_tableGeneral__Cnao8","tableGeneralHeader":"ReportsTable_tableGeneralHeader__F8uGw"};